import { render, staticRenderFns } from "./MallAdModal.vue?vue&type=template&id=19b98fab&scoped=true&"
import script from "./MallAdModal.vue?vue&type=script&lang=js&"
export * from "./MallAdModal.vue?vue&type=script&lang=js&"
import style0 from "./MallAdModal.vue?vue&type=style&index=0&id=19b98fab&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b98fab",
  null
  
)

export default component.exports